import { render, staticRenderFns } from "./StatTile.vue?vue&type=template&id=6fec981d&"
import script from "./StatTile.vue?vue&type=script&lang=js&"
export * from "./StatTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports